// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"85686f55","377":"7059d8b7","434":"291c6b7e","749":"61b484ae","787":"9c4083a9"}[chunkId] + ".chunk.js";
};